import React from "react";
import HomeContent from "../function-components/HomeContent";

function Home({bannerimg}) {
  return (
    <>
      <HomeContent bannerimg={bannerimg}/>
    </>
  );
}

export default Home;
